// Basic mobile service for compatibility

export class MobileService {
  private static instance: MobileService;

  static getInstance(): MobileService {
    if (!MobileService.instance) {
      MobileService.instance = new MobileService();
    }
    return MobileService.instance;
  }

  initialize(): void {
    // Silent initialization
  }

  cleanup(): void {
    // No-op for compatibility
  }
}

// Export singleton instance
export const mobileService = MobileService.getInstance();